export class Menu {
    constructor(
        public id: number,
        public name: string,
        public icon: string,
        public rota: string,
        public href: string,
        public HasSubMenu: boolean,
        public SubMenus: Array<SubMenu>
    ) {
    }
}
export class SubMenu {
    constructor(
        public id: number,
        public name: string,
        public icon: string,
        public rota: string
    ) {
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/models/menu.ts